import moment from 'moment';

import { SelectorOption } from '@/components/table/TableUtils';
import { MetricDataPoint } from '@/models/statsModels';

export const buildDateWithTime = (date?: string) => {
  if (!date) return '';
  const day = moment(date).format('YYYY-MM-DD h:m A');
  // const day = date ?? new Date(); const yyyy = day.getFullYear(); let mm = day.getMonth(); let dd = day.getDay()-1
  return day;
};

// adds or subtracts days from date, includeStartDate will include the start date in the calculation
export const addDays = (date: Date, amount: number, includeStartDate?: boolean) => {
  let startDate: Date = date;
  if (includeStartDate) {
    // including start date in calculation
    startDate.setDate(Math.sign(amount) === -1 ? date.getDate() + 1 : date.getDate() - 1);
  }
  startDate.setDate(startDate.getDate() + amount);
  return startDate;
};

export const addMonths = (date: Date, months: number) => {
  let newDate = date;
  newDate.setMonth(date.getMonth() + months);
  return newDate;
};

export const buildDate = (date?: Date, peristUtc: boolean = true, format?: string) => {
  if (!(date instanceof Date)) return '';
  let day = moment(date?.toISOString()).format(format || 'M/D/yyyy');
  if (peristUtc && date) day = moment(date.toISOString()).format(format || 'M/D/yyyy');
  return day;
};

export const formatDate = (date: moment.MomentInput) => moment(date).format('YYYY-MM-DD');

export const formatTimeStampDate = (timestamp: number, format?: string) => {
  return moment.unix(timestamp).format(format || 'MM/DD/YYYY');
};

export const formatTimeStampDateToMonth = (timestamp: number, format?: string) => {
  return moment.unix(timestamp).format(format || 'MMMM');
};

export const formatTimeSeriesByDay = (data: any) => {
  return data.map((metric: any) => {
    const formattedValues = metric?.values?.map((value: any) => {
      if (value.time) {
        return {
          ...value,
          time: formatTimeStampDate(value.time),
        };
      }
      return {
        time: formatTimeStampDate(value[0] as number),
        value: value[1] as number,
      };
    });
    return { ...metric, values: formattedValues as MetricDataPoint[] };
  });
};

export const formatTimeSeriesByMonth = (data: any) => {
  return data.map((metric: any) => {
    const formattedValues = metric?.values?.map((value: any) => {
      if (value.time) {
        return {
          ...value,
          time: formatTimeStampDateToMonth(value.time),
        };
      }
      return {
        time: formatTimeStampDateToMonth(value[0] as number),
        value: value[1] as number,
      };
    });
    return { ...metric, values: formattedValues as MetricDataPoint[] };
  });
};

export const calculateStartDate = (option: SelectorOption<any>): string => {
  let startDate: Date = new Date();
  const dateFormat = 'YYYY-MM-DD';

  switch (option.label) {
    case '6 Months':
      startDate = addMonths(new Date(), -option.value);
      break;
    case 'This Year':
      startDate = new Date(new Date().getFullYear(), 0, 1);
      break;
    case 'Last Year':
      startDate = new Date(new Date().getFullYear() - 1, 0, 1);
      break;
    default:
      startDate = addDays(new Date(), -option.value);
      break;
  }
  return buildDate(startDate, false, dateFormat);
};

export const getTodayDate = () => {
  const dateFormat = 'YYYY-MM-DD';
  return buildDate(new Date(), false, dateFormat);
};
